module.exports = __webpack_public_path__ + "img/pouch.886bc144.svg";